import { BreadcrumbItem } from 'components/breadcrumb/breadcrumbModel';
import { AttributeDrilldownBreadcrumb } from 'pages/trading/AttributeDrilldownBreadcrumb';
import { ReactElement } from 'react';
import { MarketshareBreadCrumb } from 'pages/trading/marketshare/MarketshareBreadCrumb';
import { BREADCRUMB_SEGMENTS, BreadcrumbSegment } from './breadcrumbConstants';
import { PriceAnalysisPageBreadcrumb } from 'pages/trading/price/PriceAnalysisPageBreadcrumb';
import { DemandMonitoringHomeBreadcrumb } from 'pages/insights-pro/performance-tab/reports/demand-monitoring/DemandMonitoringHomeBreadcrumb';
import { ProfitabilityBreadcrumb } from 'pages/Profitability/components/ProfitabilityBreadcrumb';

export interface BreadcrumbOrderingRule {
  target: string;
  successor: string;
}

export const COMPOUND_BREADCRUMB_RULES: BreadcrumbSegment[] = [
  BREADCRUMB_SEGMENTS.PRODUCTS,
  BREADCRUMB_SEGMENTS.REPORTS,
];

export const NATURAL_BREADCRUMB_EXCEPTIONS: BreadcrumbOrderingRule[] = [
  {
    target: BREADCRUMB_SEGMENTS.REPORTS,
    successor: BREADCRUMB_SEGMENTS.PRODUCTS,
  },
];

export const ATTRIBUTE_DETAIL_URLS = [
  '/steeringhub/insightsfeed/detail',
  '/steeringhub/insightsfeed/drilldown',
  '/steeringhub/insightsfeed/marketshare',
  '/steeringhub/insightsfeed/price-analysis',
  '/insights/performance/reports/demand-monitoring/detail',
  '/profitability/drilldown',
];

export const DRILLDOWN_HOMES = {
  demand: ['/insights/performance/reports/demand-monitoring/detail'],
};

export const CUSTOM_BREADCRUMBS: Record<string, (breadcrumb: BreadcrumbItem) => ReactElement> = {
  '/profitability/drilldown': breadcrumb => <AttributeDrilldownBreadcrumb breadcrumbItem={breadcrumb} />,
  '/profitability/': breadcrumb => <ProfitabilityBreadcrumb breadcrumbItem={breadcrumb} />,
  '/steeringhub/insightsfeed/detail': breadcrumb => (
    <AttributeDrilldownBreadcrumb breadcrumbItem={breadcrumb} includeDate={true} />
  ),
  '/steeringhub/insightsfeed/drilldown': breadcrumb => <AttributeDrilldownBreadcrumb breadcrumbItem={breadcrumb} />,
  '/steeringhub/insightsfeed/marketshare': breadcrumb => <MarketshareBreadCrumb breadcrumbItem={breadcrumb} />,
  '/steeringhub/insightsfeed/price-analysis': breadcrumb => <PriceAnalysisPageBreadcrumb breadcrumbItem={breadcrumb} />,
  '/steeringhub/insightsfeed/price-analysis/style': breadcrumb => (
    <PriceAnalysisPageBreadcrumb breadcrumbItem={breadcrumb} />
  ),
  '/insights/performance/reports/demand-monitoring/detail': breadcrumb => (
    <AttributeDrilldownBreadcrumb breadcrumbItem={breadcrumb} />
  ),
  '/insights/performance/reports/demand-monitoring/home': _ => <DemandMonitoringHomeBreadcrumb />,
};

export const REDIRECTS: Record<string, string> = {
  '/product': '/insights/product',
  '/category': '/insights/category',
};

export const SKIPPED_BREADCRUMBS: string[] = [`reports/demand-monitoring`];
